import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-admin-catalogue',
  templateUrl: './admin-catalogue.component.html',
  styleUrls: ['./admin-catalogue.component.scss'],
})
export class AdminCatalogueComponent implements OnInit {
  constructor(public api: ApiService, private http: HttpClient) {}

  catalogues: any;
  uploading: { [key: number]: boolean } = {};

  ngOnInit() {
    this.refresh();
  }
  refresh(): void {
    this.api.post('SPDO=select', { database: 'catalogue' }).then((res: any) => {
      this.catalogues = res.data;
    });
  }

  addRow() {
    this.catalogues = [
      ...this.catalogues,
      { position: this.catalogues.length + 1, edit: true },
    ];
  }

  onFileSelect(event: any, row: any) {
    const file = event.files?.[0];
    if (!file) return;
    row._file = file;
    row._fileName = file.name;
  }

  uploadAndSave(row: any) {
    if (row._file) {
      const idx = this.catalogues.indexOf(row);
      this.uploading[idx] = true;
      const formData = new FormData();
      formData.append('file', row._file);
      this.http.post<any>(
        this.api.url + this.api.crypt('catalogue=uploadCatalogue'),
        formData
      ).subscribe({
        next: (res) => {
          if (res.success) {
            row.url = res.url;
          }
          delete row._file;
          delete row._fileName;
          this.saveRow(row, idx);
        },
        error: (err) => {
          this.uploading[idx] = false;
          this.api.error('Erreur lors de l\'upload du fichier');
        }
      });
    } else {
      this.saveRow(row, this.catalogues.indexOf(row));
    }
  }

  private saveRow(row: any, idx: number) {
    row.edit = undefined;
    this.api
      .post('SPDO=insert', {
        database: 'catalogue',
        data: row,
      })
      .then((res: any) => {
        this.uploading[idx] = false;
        this.refresh();
      });
  }

  save(row: any) {
    this.uploadAndSave(row);
  }

  uploadingRSE = false;
  rseUrl = 'https://cdn.blackrockgames.fr/catalogs/bilan_RSE.pdf';

  onRSESelect(event: any) {
    const file = event.files?.[0];
    if (!file) return;
    this.uploadingRSE = true;
    const formData = new FormData();
    formData.append('file', file);
    this.http.post<any>(
      this.api.url + this.api.crypt('catalogue=uploadBilanRSE'),
      formData
    ).subscribe({
      next: (res) => {
        this.uploadingRSE = false;
        if (res.success) {
          this.rseUrl = res.url;
          this.api.success('Bilan RSE uploadé avec succès');
        }
      },
      error: () => {
        this.uploadingRSE = false;
        this.api.error('Erreur lors de l\'upload du Bilan RSE');
      }
    });
  }

  delete(row: any) {
    this.api
      .confirm('Êtes-vous sûr de vouloir supprimer cette ligne ?')
      .then((res: any) => {
        if (res == 'ok') {
          this.api
            .post('catalogue=deleteCatalogue', {
              id_catalogue: row.id_catalogue,
            })
            .then((res: any) => {
              this.refresh();
            });
        }
      });
  }
}
